import { IPeriodTime } from 'interfaces/commons/IPeriodTime'
import { PHONE_NUMBER_REG } from 'utils/regularExpressions'

const clinic_id = Number(localStorage.getItem('clinic_id'))
export const handleSearch = (
  inputSearch: string,
  onSearch?: (val: IPeriodTime) => void,
  payload?: any
) => {
  if (inputSearch?.length < 2) {
    inputSearch = ''
  }
  const isPhoneNumber = PHONE_NUMBER_REG.test(inputSearch)
  const newQuery = {
    ...payload,
    clinic_id: clinic_id,
    phone_number: isPhoneNumber ? inputSearch : undefined,
    search: !isPhoneNumber && inputSearch ? inputSearch : undefined
  }
  onSearch && onSearch(newQuery)
}

export const handleSearch2 = (
  inputSearch: string,
  onSearch?: (val: IPeriodTime) => void,
  payload?: any
) => {
  if (inputSearch?.length < 2) {
    inputSearch = ''
  }
  const isPhoneNumber = PHONE_NUMBER_REG.test(inputSearch)
  const newQuery = {
    ...payload,
    clinic_id: clinic_id,
    patient_phone_number: isPhoneNumber ? inputSearch : undefined,
    search: !isPhoneNumber && inputSearch ? inputSearch : undefined
  }
  onSearch && onSearch(newQuery)
}
